export default "__VITE_ASSET__BX6URI4Q__"